import React, { useState, useEffect } from "react";
import { Select } from "@windmill/react-ui";

import VehicleModelServices from "services/VehicleModelServices";

const SelectVehicle = ({
  register,
  vehicleType,
  name,
  defaultValue,
  required,
  onChange,
  label,
  selectedVehicle,
  selectedOptions,
  ...props
}) => {
  const [allVehicleCategory, setVehicleCategory] = useState([]);
  useEffect(() => {
    async function fetchVehicleCategory() {
      try {
        const response = await VehicleModelServices.getAllVehicleModel();

        setVehicleCategory(response.data);
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    }

    fetchVehicleCategory();
  }, []);

  return (
    <Select
      className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      name={name}
      {...register(name, required ? { required: `${label} is required!` } : {})}
      {...props}
      value={defaultValue}
      onChange={onChange}
    >
      <option value="">Select Model</option>
      {Array.isArray(allVehicleCategory) && allVehicleCategory.length > 0 ? (
        allVehicleCategory.map((category) => (
          <option
            key={category.id}
            value={category.id}
            disabled={selectedOptions?.includes(String(category.id))}
          >
            {category.name}
          </option>
        ))
      ) : (
        <option>Loading...</option>
      )}
    </Select>
  );
};

export default SelectVehicle;
